/* LINEA NERA — theme interactions v2 */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Mobile nav ---------- */
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-site-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---------- Animated pill nav cursor ---------- */
  var pill = document.querySelector('[data-navpill]');
  if (pill) {
    var cursor = pill.querySelector('[data-navpill-cursor]');
    var tabs = Array.prototype.slice.call(pill.querySelectorAll('[data-navpill-tab]'));
    var active = tabs.filter(function (t) { return t.hasAttribute('data-current'); })[0] || tabs[0];
    function pillMoveTo(tab) {
      if (!tab || !cursor) return;
      cursor.style.left = tab.offsetLeft + 'px';
      cursor.style.width = tab.offsetWidth + 'px';
      tabs.forEach(function (t) { t.classList.toggle('is-on', t === tab); });
    }
    function pillReset() { pillMoveTo(active); }
    pillReset();
    window.addEventListener('load', pillReset);
    window.addEventListener('resize', pillReset);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(pillReset); }
    tabs.forEach(function (t) { t.addEventListener('mouseenter', function () { pillMoveTo(t); }); });
    pill.addEventListener('mouseleave', pillReset);
  }

  if (reduce) {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
    document.querySelectorAll('[data-count]').forEach(function (el) { el.textContent = el.getAttribute('data-count'); });
    return;
  }

  /* ---------- Count-up stats ---------- */
  var counters = document.querySelectorAll('[data-count]');
  if ('IntersectionObserver' in window && counters.length) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        cio.unobserve(el);
        var target = parseFloat(el.getAttribute('data-count')) || 0;
        var dur = 1400, start = null;
        function tick(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased).toString();
          if (p < 1) requestAnimationFrame(tick);
          else el.textContent = target.toString();
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.5 });
    counters.forEach(function (el) { cio.observe(el); });
  }

  /* ---------- Entry reveal with stagger ---------- */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    // stagger siblings sharing a parent grid/row
    reveals.forEach(function (el) {
      var siblings = el.parentElement ? el.parentElement.querySelectorAll(':scope > .reveal') : [];
      if (siblings.length > 1) {
        var idx = Array.prototype.indexOf.call(siblings, el);
        if (idx > 0) el.style.transitionDelay = Math.min(idx * 90, 540) + 'ms';
      }
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Center-focus: highlight cards near viewport centre ---------- */
  var focusEls = Array.prototype.slice.call(document.querySelectorAll('[data-focus]'));
  if (focusEls.length) {
    var ticking = false;
    var band = 0.30; // +-30% of viewport height around centre
    function updateFocus() {
      var vh = window.innerHeight;
      var centre = vh / 2;
      focusEls.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) { el.classList.remove('in-focus'); return; }
        var elCentre = r.top + r.height / 2;
        var dist = Math.abs(elCentre - centre) / vh;
        el.classList.toggle('in-focus', dist < band);
      });
      ticking = false;
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(updateFocus); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updateFocus();
  }

  /* ---------- Reviews shuffle stack ---------- */
  var stack = document.querySelector('[data-rstack]');
  if (stack) {
    var cards = Array.prototype.slice.call(stack.querySelectorAll('[data-rcard]'));
    if (cards.length > 1) {
      stack.classList.add('rstack--active');
      var dotsWrap = document.querySelector('[data-rstack-dots]');
      var order = cards.map(function (_, i) { return i; });
      var dots = [];
      function layout() {
        order.forEach(function (cardIdx, pos) {
          var card = cards[cardIdx];
          card.dataset.pos = pos === 0 ? 'front' : pos === 1 ? 'middle' : pos === 2 ? 'back' : 'hidden';
          card.style.transform = '';
          card.removeAttribute('data-dragging');
          card.setAttribute('aria-hidden', pos === 0 ? 'false' : 'true');
        });
        dots.forEach(function (d, i) { d.setAttribute('aria-current', i === order[0] ? 'true' : 'false'); });
      }
      function next() { order.push(order.shift()); layout(); }
      function goTo(idx) { var g = 0; while (order[0] !== idx && g < cards.length) { order.push(order.shift()); g++; } layout(); }
      if (dotsWrap) {
        cards.forEach(function (_, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Recensione ' + (i + 1));
          b.addEventListener('click', function () { goTo(i); });
          dotsWrap.appendChild(b); dots.push(b);
        });
      }
      layout();

      var startX = 0, dragging = false, moved = false, current = null;
      function down(e) {
        var card = cards[order[0]];
        if (!e.target.closest('[data-rcard]') || e.target.closest('[data-rcard]') !== card) return;
        dragging = true; moved = false; current = card; card.setAttribute('data-dragging', '');
        startX = e.touches ? e.touches[0].clientX : e.clientX;
      }
      function move(e) {
        if (!dragging || !current) return;
        var x = e.touches ? e.touches[0].clientX : e.clientX;
        var dx = x - startX;
        if (Math.abs(dx) > 6) moved = true;
        current.style.transform = 'rotate(' + (-4 + dx * 0.04) + 'deg) translateX(' + dx + 'px)';
      }
      function up(e) {
        if (!dragging || !current) return;
        var x = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
        var dx = x - startX;
        current.removeAttribute('data-dragging');
        if (Math.abs(dx) > 100) next(); else layout();
        dragging = false; current = null;
      }
      stack.addEventListener('mousedown', down);
      window.addEventListener('mousemove', move);
      window.addEventListener('mouseup', up);
      stack.addEventListener('touchstart', down, { passive: true });
      window.addEventListener('touchmove', move, { passive: true });
      window.addEventListener('touchend', up);
      cards.forEach(function (card) {
        card.addEventListener('click', function () { if (!moved && card.dataset.pos === 'front') next(); });
        card.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && card.dataset.pos === 'front') { e.preventDefault(); next(); } });
      });
    }
  }
})();
